// extracted by mini-css-extract-plugin
export default {"cta":"DG-z","disabled":"EG-z"};